// extracted by mini-css-extract-plugin
export default {"textArea":"textArea---lM3gz","fullWidth":"fullWidth---k7TOw"};